import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

const DEPARTMENT_BY_NUMBERS = {
  0: "Hỗ trợ kinh doanh",
  1: "Kinh doanh",
};

async function fetchConstantData(saleAreaId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let searchSaleBlockQueryParams = searchQueryParams;
  // if (saleAreaId)
  //   searchSaleBlockQueryParams =
  //     searchQueryParams + "&" + new URLSearchParams({ saleAreaId }).toString();

  // Fetch constant data concurrently
  const [
    jobPositionBussinesData,
    jobPositionSupportBussinesData,
    saleBlockData,
    saleAreaData,
    branchData,
    supportDepartmentData,
    businessCategoryData,
    salesPerson,
    businessSupportStaff,
  ] = await Promise.all([
    clientAPI("get", "/jobPosition/allowType?type=1"),
    clientAPI("get", "/jobPosition/allowType?type=0"),
    clientAPI("get", `/saleBlock?${searchSaleBlockQueryParams}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/branch?${searchQueryParams}`),
    clientAPI("get", `/supportDepartment?${searchQueryParams}`),
    clientAPI("get", `/businessCategory?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryParams}`),
  ]);

  return {
    departmentByNumbers: DEPARTMENT_BY_NUMBERS,

    jobPositionBussines: jobPositionBussinesData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    jobPositionSupportBussines: jobPositionSupportBussinesData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleBlocks: saleBlockData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleAreas: saleAreaData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    branches: branchData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    supportDepartments: supportDepartmentData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    businessCategorys: businessCategoryData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employeeSalesPerson: salesPerson?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    employeeBusinessSupportStaff: businessSupportStaff?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
  };
}

export function useCategories(saleAreaId) {
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories15", saleAreaId],
    queryFn: () => fetchConstantData(saleAreaId),
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}